<div class="details-container">
  <div class="details-content">
    <form class="details-form" [formGroup]="detailsForm">
      <div class="form-content">
        <div class="secondary-text" style="display: inline-flex; gap: 20px; align-items: center;">
          {{ 'commission.new.commission_type' | translate }}
            <span class="commission-type-tag">
                <app-svg-icon [svgIcon]="commission.type === 'base' ? 'percentage-cc': 'tag-cc'"></app-svg-icon>
                {{ 'commission.type.' + commissionType | translate }}
            </span>
        </div>
        <hr />
        <div class="standard-input">
          <label for="commission-name"> {{ "commission.new.profile_name" | translate }} </label>
          <input type="text" id="commission-name" placeholder="ex. “Base Commission 2025”" formControlName="name" />
          <div class="error" *ngIf="detailsForm.get('name')?.invalid && (detailsForm.get('name')?.touched || detailsForm.get('name')?.dirty)">
            <small *ngIf="detailsForm.get('name')?.hasError('required')">
              {{ "validation.required" | translate }}
            </small>
          </div>
        </div>
        <div class="standard-input">
          <label for="commission-desc">
            {{ "commission.new.internal_desc" | translate }}
            <span class="secondary-text" style="font-size: 14px">({{ "common.optional" | translate }})</span>
          </label>
          <textarea
            id="commission-desc"
            autocomplete="off"
            placeholder="eg. “Base commission to be applied to every Agent in Italy”"
            formControlName="description"
            rows="4"
            style="resize: vertical"
          ></textarea>
          <div
            class="error"
            *ngIf="detailsForm.get('description')?.invalid && (detailsForm.get('description')?.touched || detailsForm.get('description')?.dirty)"
          >
            <small *ngIf="detailsForm.get('description')?.hasError('required')">
              {{ "validation.required" | translate }}
            </small>
          </div>
        </div>
        <ng-container *ngIf="commissionType === 'brand'">
          <!-- Brands -->
          <div>
            <span class="label">{{ "brands.brands" | translate }}</span>
            <mat-chip-list #brandChipList>
              <mat-chip *ngFor="let brand of selectedBrands" [selectable]="true" [removable]="true" (removed)="removeBrand(brand)" class="brand">
                {{ brand.name }}
                <mat-icon matChipRemove>close</mat-icon>
              </mat-chip>
              <input
                *ngIf="selectedBrands.length != brands.length"
                name="brand"
                placeholder="{{ 'agent.details.select_placeholder' | translate }}"
                #brandInput
                [formControl]="brandControl"
                [matAutocomplete]="brandAuto"
                [matChipInputFor]="brandChipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="false"
                (matChipInputTokenEnd)="addBrandFromInput($event)"
              />
            </mat-chip-list>
            <mat-autocomplete #brandAuto="matAutocomplete" (optionSelected)="selectBrand($event.option.value)">
              <mat-option *ngFor="let brand of filteredBrands | async" [value]="brand">
                {{ brand.name }}
              </mat-option>
            </mat-autocomplete>
            <div class="error" *ngIf="detailsForm.get('brands')?.invalid && (detailsForm.get('brands')?.dirty || detailsForm.get('brands')?.touched)">
              <small *ngIf="detailsForm.get('brands')?.hasError('atLeastOne')">
                {{ "validation.atleast_one" | translate : { option: "brand" } }}
              </small>
            </div>
          </div>
          <!-- Labels -->
          <div>
            <span class="label">{{ "Labels.labels" | translate }} ({{ "common.optional" | translate }})</span>
            <mat-chip-list #labelChipList>
              <mat-chip *ngFor="let label of selectedLabels" [selectable]="true" [removable]="true" (removed)="removeLabel(label)" class="label">
                {{ label.name }}
                <mat-icon matChipRemove>close</mat-icon>
              </mat-chip>
              <input
                *ngIf="selectedLabels.length != labels.length"
                name="label"
                placeholder="{{ 'agent.details.select_placeholder' | translate }}"
                #labelInput
                [formControl]="labelControl"
                [matAutocomplete]="labelAuto"
                [matChipInputFor]="labelChipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="false"
                (matChipInputTokenEnd)="addLabelFromInput($event)"
              />
              <span *ngIf="labels.length === 0">
                {{ "agent.single_agent.catalogs.no_data" | translate }}
              </span>
            </mat-chip-list>
            <mat-autocomplete #labelAuto="matAutocomplete" (optionSelected)="selectLabel($event.option.value)">
              <mat-option *ngFor="let label of filteredLabels | async" [value]="label">
                {{ label.name }}
              </mat-option>
            </mat-autocomplete>
          </div>
          <!-- Categories -->
          <div>
            <span class="label">{{ "Categories.categories" | translate }} ({{ "common.optional" | translate }})</span>
            <mat-chip-list #categoryChipList>
              <mat-chip
                *ngFor="let category of selectedCategories"
                [selectable]="true"
                [removable]="true"
                (removed)="removeCategory(category)"
                class="category"
              >
                {{ category.name }}
                <mat-icon matChipRemove>close</mat-icon>
              </mat-chip>
              <input
                *ngIf="selectedCategories.length != categories.length"
                name="category"
                placeholder="{{ 'agent.details.select_placeholder' | translate }}"
                #categoryInput
                [formControl]="categoryControl"
                [matAutocomplete]="categoryAuto"
                [matChipInputFor]="categoryChipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="false"
                (matChipInputTokenEnd)="addCategoryFromInput($event)"
              />
              <span *ngIf="categories.length === 0"> {{ "agent.single_agent.catalogs.no_data" | translate }} </span>
            </mat-chip-list>
            <mat-autocomplete #categoryAuto="matAutocomplete" (optionSelected)="selectCategory($event.option.value)">
              <mat-option *ngFor="let category of filteredCategories | async" [value]="category">
                {{ category.name }}
              </mat-option>
            </mat-autocomplete>
          </div>
        </ng-container>
        <div class="standard-input has-icon">
          <label for="base-commission-percentage"> {{ "commission.new.base_commission" | translate }} </label>
          <div class="input-container">
            <input
              type="number"
              min="0"
              max="100"
              id="base-commission-percentage"
              placeholder="ex. “Base Commission 2025”"
              formControlName="commission"
              (input)="onInputRemoveLeadingZero($event, detailsForm, 'commission')"
            />
            <span class="btn-icon" style="cursor: default">
              <app-svg-icon svgIcon="percentage-cc"></app-svg-icon>
            </span>
          </div>
          <div
            class="error"
            *ngIf="detailsForm.get('commission')?.invalid && (detailsForm.get('commission')?.touched || detailsForm.get('commission')?.dirty)"
          >
            <small *ngIf="detailsForm.get('commission')?.hasError('required')">{{ "validation.required" | translate }}</small>
            <small *ngIf="detailsForm.get('commission')?.hasError('min')">{{
              "validation.min"
                | translate
                  : {
                      min: detailsForm.get("commission")?.getError("min").min + "%"
                    }
            }}</small>
            <small *ngIf="detailsForm.get('commission')?.hasError('max')">{{
              "validation.max"
                | translate
                  : {
                      max: detailsForm.get("commission")?.getError("max").max + "%"
                    }
            }}</small>
          </div>
        </div>
        <div class="standard-input">
          <label for="calculation-method"> {{ "commission.new.calculation_method" | translate }} </label>
          <select id="calculation-method" formControlName="calculation_method">
            <option [value]="item.value" *ngFor="let item of commissionCalculationTypes">
              {{ item.label }}
            </option>
          </select>
        </div>
        <hr />
        <div style="display: flex; gap: 10px; align-items: center">
          <mat-checkbox [checked]="hasExpirationDate" (change)="toggleExpirationDate()"> </mat-checkbox>
          <span class="checkbox-text"> {{ "commission.new.has_expiration_date" | translate }} </span>
        </div>
        <div class="standard-input has-icon" *ngIf="hasExpirationDate">
          <label for="expiry_date">{{ "Catalogs.new_catalog.settings.select_expiration_date" | translate }} </label>
          <div class="input-container">
            <input
              type="text"
              [matDatepicker]="picker"
              formControlName="expiry_date"
              [placeholder]="'Catalogs.new_catalog.settings.select_date' | translate"
              readonly="true"
              (click)="picker.open()"
            />
            <button type="button" class="btn-icon" (click)="picker.open()" tabindex="-1" aria-label="Open calendar">
              <app-svg-icon svgIcon="calendar-cc"></app-svg-icon>
            </button>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div
            class="error"
            *ngIf="detailsForm.get('expiry_date')?.invalid && (detailsForm.get('expiry_date')?.touched || detailsForm.get('expiry_date')?.dirty)"
          >
            <small *ngIf="detailsForm.get('expiry_date')?.hasError('required')">
              {{ "validation.required" | translate }}
            </small>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
